import { API } from '../constants/constants';
import { Engagement, EngagementRequestPayload, UpdateEngagementWithFilesMutationProps } from '../types';
import { normalizeToIds } from '../../utils/eventHandlerUtils';

export const buildEngagementRequestPayload = (payload: Engagement): EngagementRequestPayload => {
  const requestPayload = {
    ...payload,
    communityMembers: normalizeToIds(payload.communityMember),
    organizations: normalizeToIds(payload.organization),
  };
  delete requestPayload.communityMember;
  delete requestPayload.organization;
  return requestPayload;
};

export const getMonthlyEngagements = async (month: string, timezoneOffset: string) => {
  const res = await API.get('/engagements/monthly', {
    params: {
      month,
      timezoneOffset,
    },
  });
  return res.data;
};

export const createEngagement = async (payload: EngagementRequestPayload) => {
  const res = await API.post(`/engagement`, payload);
  return res;
};

interface UploadEngagementFilesURLProps {
  id: string;
  files: File[];
}

export const uploadEngagementFiles = async ({ id, files }: UploadEngagementFilesURLProps) => {
  const formData = new FormData();
  files.filter((file) => file.type !== 'url').forEach((file) => formData.append('file', file));

  return API.post(`/engagement/${id}/upload`, formData, {
    headers: { 'content-type': 'multipart/form-data' },
  });
};

interface UploadEngagementURLProps {
  id: string;
  file: File;
}

export const uploadEngagementUrl = async ({ id, file }: UploadEngagementURLProps) => {
  return API.post(`/engagement/${id}/url`, file);
};

export const updateEngagementWithFiles = async ({
  id,
  fields,
  uploadingFiles,
  uploadingUrls,
  removingFiles,
  removingUrls,
}: UpdateEngagementWithFilesMutationProps) => {
  const formData = new FormData();
  for (const file of uploadingFiles) {
    formData.append('file', file);
  }
  formData.append('urls', JSON.stringify(uploadingUrls));
  formData.append('deletingFiles', JSON.stringify(removingFiles));
  formData.append('deletingUrls', JSON.stringify(removingUrls));
  const normalizedFields = buildEngagementRequestPayload(fields);
  formData.append('fields', JSON.stringify(normalizedFields));

  const res = await API.put(`/engagements/${id}/update`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
};

export const deleteEngagement = async (id: string) => {
  const res = await API.delete(`/engagement/${id}`);
  return res.data;
};

export const getFilteredEngagements = async (filterQueryString: string) => {
  const res = await API.get(`engagements/filter?${filterQueryString}`);
  return res.data?.data;
};

export const getFuzzySearchEngagements = async (queryString: string, category: string) => {
  const res = await API.get(`/engagements/fuzzySearch?queryString=${queryString}&category=${category}`);
  return res.data?.data;
};
